// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// styles
import { resetButton } from 'shared/styles/mixin';

const Container = styled.div`
  display: flex;
  position: absolute;
  height: 40px;
  width: 100%;
  bottom: 0;
  background: rgba(255, 255, 255, 0.4);
  align-items: center;
  justify-content: center;
`;

const DotButton = styled.button<{ isActive: boolean }>`
  ${resetButton}
  height: 8px;
  width: 8px;
  background: ${({ theme }) => theme.colors.textSecondary};
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    `
    height: 8px;
      width: 8px;
      background: #000;
  `}

  &:last-child {
    margin-right: 0;
  }
`;

// def
interface IDotsProps {
  currentSlide: number;
  numberOfSlides: number;
  onSelect?: (id: number) => void;
  videoSlides?: number[];
  className?: string;
  dotClassName?: string;
  videoDotClassName?: string;
  activeClassName?: string;
}

const IMAGE_NAVIGATION_LABEL_PREFIX = 'Navigate Image number ';
const EMPTY_ARRAY: number[] = [];

function Dots({
  currentSlide,
  numberOfSlides,
  onSelect,
  videoSlides = EMPTY_ARRAY,
  className = '',
  dotClassName = '',
  videoDotClassName = '',
  activeClassName = '',
}: IDotsProps) {
  if (numberOfSlides < 2) {
    return null;
  }

  const slides = [];
  const onSelection = (id: number) => {
    onSelect && onSelect(id);
  };

  for (let i = 0; i < numberOfSlides; i++) {
    slides.push(i);
  }

  return (
    <Container className={className}>
      {slides.map((index) => {
        const isActive = currentSlide === index;
        const btnClassName = [
          dotClassName,
          isActive && activeClassName,
          videoSlides.includes(index) && videoDotClassName,
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <DotButton
            aria-label={IMAGE_NAVIGATION_LABEL_PREFIX + index}
            key={"dot-" + index}
            className={btnClassName}
            onClick={() => onSelection(index)}
            isActive={isActive}
          />
        );
      })}
    </Container>
  );
}

export default memo(Dots);
